module.exports = __webpack_public_path__ + "static/img/13020B_7_8_R_20221019_fit.4f96ba7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/13020B_7_8_R_20221019_fit.png
// module id = zGuX
// module chunks = 0